import SplashStory from './SplashStory';
import {
  CITIZEN_LOGIN_PATH,
  CITIZEN_PLAY_STORE,
  CITIZEN_SPLASH_SCREENS,
  CITIZEN_STORY_UI,
} from './loksy-landing/citizenSplash';

export default function LoksyAppStory() {
  return (
    <SplashStory
      screens={CITIZEN_SPLASH_SCREENS}
      playStore={CITIZEN_PLAY_STORE}
      loginTo={CITIZEN_LOGIN_PATH}
      brandMark="/images/brand/loksy-mark.png"
      ui={CITIZEN_STORY_UI}
      documentTitle="Loksy App — Your Town. Just One Tap Away."
    />
  );
}
